import { gql } from '@apollo/client';
import { insuranceFragment } from 'store/fragments';

export default gql`
  query booking($reference: String!) {
    booking(reference: $reference) {
      salesChannelCode
      reference
      additionalDetails {
        value
        key
        itemRef
        passengerRef
      }
      totalPriceToBePaid
      isGroupBooking
      status
      displayStatus @client
      isInAfterSales
      currency
      arePassengersEditable @client
      createTimestamp
      confirmedTimestamp
      cancelledTimestamp
      notes {
        createdAt
      }
      nonExchangedOutbound: outbound(hideExchanged: true) {
        id
      }
      nonExchangedInbound: inbound(hideExchanged: true) {
        id
      }
      allBookingItems @client {
        ...product
        status
      }
      passengers {
        ...passenger
      }
      customer {
        firstName
        lastName
        email
        phoneNumber
        unformattedPhoneNumber {
          countryCode
          number
        }
        address {
          street
          postalCode
          city
          countryCode
        }
      }
      outbound(hideExchanged: true, sortByDepartureDate: true) {
        ...leg
      }
      inbound(hideExchanged: true, sortByDepartureDate: true) {
        ...leg
      }
      outboundExtras {
        ...product
      }
      inboundExtras {
        ...product
      }
      agent {
        organization
        office
        username
      }
      productFamily
      productFamilyGroup
      externalBookingReferences {
        source
        externalId
      }
      payments {
        id
        refId
        method
        paymentStatus
      }
      wasPurchasedWithSubscription
      insurances {
        ...CompleteInsurance
      }
      latestRevisionSource {
        username
      }
    }
  }

  fragment leg on Leg {
    ...legFields
    addOnLeg {
      ...legFields
    }
  }

  fragment legFields on Leg {
    cancelled
    origin {
      name
    }
    destination {
      name
    }
    timing {
      date
      isoDate
    }
    serviceType {
      code
    }
    products {
      ...product
    }
    bookingItems @client {
      ...product
      status
    }
  }

  fragment passenger on Passenger {
    id
    refId
    uuid
    type
    firstName
    lastName
    email
    phoneNumber
    unformattedPhoneNumber {
      countryCode
      number
    }
    birthDate
    loyaltyNumber
    disabilityType
    discountCards {
      code
      identifier
      name
      requiresPassengerIdentifier
    }
    travelDocumentsRequired {
      travelDocumentType
      required
    }
  }

  fragment product on Product {
    uuid
    passengerId
    isCheckedIn
    isSuspended
    isPlaceholder
    isUKEntryDenied
    externalTicketNumber
    externalProductReference
    isExpired
    cancelled
    voidTimestamp
    expiryTimestamp
    provisional
    inventoryClass
    price
    itemId
    itemRef
    canBeCancelled
    canChangeName
    ticketNumber
    passenger {
      ...passenger
    }
    additionalDetails {
      key
      value
    }
  }

  ${insuranceFragment}
`;
